import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatNum, extractErrorMessage } from "@/lib/api";

export function TahsilatMonthsPicker({ primId, months, onApplied }) {
  const [sel, setSel] = useState(() => new Set(months.filter((m) => m.current).map((m) => m.ym)));
  const [busy, setBusy] = useState(false);
  const total = months.filter((m) => sel.has(m.ym)).reduce((s, m) => s + m.tahsilat, 0);
  const toggle = (ym) => setSel((s) => { const n = new Set(s); n.has(ym) ? n.delete(ym) : n.add(ym); return n; });

  const apply = async () => {
    setBusy(true);
    try {
      await api.post(`/prim/${primId}/apply-tahsilat-months`, { months: [...sel] });
      toast.success(`Tahsilat alanına ${formatNum(total)} ₺ yazıldı`);
      onApplied?.();
    } catch (e) {
      toast.error(extractErrorMessage(e, "Tahsilat yazılamadı"));
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-1 rounded border border-slate-200 bg-slate-50 px-1.5 py-1 text-[10px] font-normal text-slate-600" data-testid={`tahsilat-months-${primId}`}>
      <div className="font-semibold text-slate-500 mb-0.5">Aylara göre tahsilat</div>
      {months.map((m) => (
        <label key={m.ym} className="flex items-center gap-1 cursor-pointer" data-testid={`tahsilat-month-${primId}-${m.ym}`}>
          <input type="checkbox" className="h-3 w-3" checked={sel.has(m.ym)} onChange={() => toggle(m.ym)}
            data-testid={`tahsilat-month-check-${primId}-${m.ym}`} />
          <span className={m.current ? "font-semibold text-slate-800" : ""}>{m.ay}{m.current ? " (primin ayı)" : ""}</span>
          <span className="ml-auto font-mono-tab whitespace-nowrap">{formatNum(m.tahsilat)} ₺</span>
        </label>
      ))}
      <button type="button" disabled={busy || sel.size === 0} onClick={apply} data-testid={`tahsilat-months-apply-${primId}`}
        className="mt-1 w-full px-1.5 py-0.5 rounded border border-indigo-300 bg-indigo-50 text-indigo-700 font-semibold hover:bg-indigo-100 disabled:opacity-50">
        {busy ? "Yazılıyor..." : `Tahsilata yaz: ${formatNum(total)} ₺`}
      </button>
    </div>
  );
}
